import { datePickerPopperClassName } from './datePickerPopperConfig';

export const readPopperPlacement = (): 'top' | 'bottom' => {
  const popper = document.querySelector(`.${datePickerPopperClassName}`);
  const placement = popper?.getAttribute('data-placement') ?? 'bottom-start';
  return placement.startsWith('top') ? 'top' : 'bottom';
};
